// utils/permissionUtils.js


import { actionPermissionApi } from "_services";
import { constant } from "constants";
import toast from "react-hot-toast";


export const actionPermission = async ({
  company_id,
  type,
  onSuccess,
  onFinally = () => { },
  setModalConfig, // <-- function to control modal (e.g., setState or Redux action)
}) => {
  try {
    const payload = { company_id, type };
    setModalConfig((prev) => ({ ...prev, isLoading: true }));
    const res = await actionPermissionApi(payload);

    if (res?.responseCode === 200) {
      setModalConfig((prev) => ({ ...prev, isLoading: false }));
      const { call_next_api, show_message, message_type, max_usage_used, template_id, template_data } = res.data || {};
      const msg = res?.responseMessage;

      if (!template_data?.template_id && !call_next_api) {
        toast.error("You don’t have permission to add a new and template not Available ")
        setModalConfig((prev) => ({ ...prev, isLoading: false }));
        return;
      }

      if (show_message && setModalConfig) {
        // const template = constant?.PERMISSION_TEMPLATES[message_type]?.[template_id];

        if (template_id && message_type && template_data?.template_id) {
          // For chargeable (1) and upgrade (3), show dynamic modal
          setModalConfig({
            isOpen: true,
            messageType: message_type,
            templateId: template_id,
            templateData: template_data,
            isLoading: false,

          });
        }
      }

      if (max_usage_used) {
        // toast.error(msg || "You have reached the maximum allowed usage.");


      }

      if (call_next_api && !max_usage_used) {
     

        onSuccess();
      }
    } else {
      toast.error("Unexpected response from server.");


    }
  } catch (error) {
    console.error("Permission check failed:", error);
    toast.error("Failed to check permissions. Please try again.");


  } finally {
    onFinally();
    setModalConfig((prev) => ({ ...prev, isLoading: false }));

  }
};